import { Toaster as SonnerToaster } from 'sonner'

import {
  ToastErrorIcon,
  ToastLoadingIcon,
  ToastSuccessIcon,
  ToastWarningIcon,
} from '~/components/component-library/Toast'

export const Toaster = ({ isMobile }: { isMobile: boolean }) => (
  <SonnerToaster
    expand={false}
    offset={32}
    visibleToasts={5}
    toastOptions={{
      unstyled: true,
      style: {
        transition: 'transform 200ms ease-out, opacity 200ms ease-out',
      },
      classNames: toastClassNames,
      duration: 8000,
    }}
    position={isMobile ? 'top-right' : 'bottom-right'}
    icons={{
      error: <ToastErrorIcon />,
      success: <ToastSuccessIcon />,
      warning: <ToastWarningIcon />,
      loading: <ToastLoadingIcon />,
    }}
  />
)

// Sonner renders the icon, content (title + description), and action button as
// flex siblings in a row. We lay them out as a 2-column grid instead so the
// action button flows into the second row of the content column — its left edge
// is derived from the icon width rather than a hand-tuned offset, keeping it
// aligned with the title and description across every toast variant.
const toastClassNames = {
  title:
    'leading-tight pointer-events-none select-none text-primary text-sm line-clamp-1 w-full',
  description:
    'leading-normal pointer-events-none select-none text-sm mt-0.5 text-secondary line-clamp-3 w-full',
  toast:
    'bg-white dark:bg-gray-800 border w-full absolute grid grid-cols-[auto_1fr] items-start gap-x-2.5 gap-y-2 border-gray-200 shadow-lg shadow-black/10 dark:border-gray-600 px-4 py-3.5 rounded-xl',
  icon: 'text-primary col-start-1 row-start-1 flex justify-center [&>svg]:h-4 [&>svg]:w-4 [&>svg]:inline',
  content: 'col-start-2 row-start-1',
  actionButton:
    'col-start-2 row-start-2 justify-self-start font-medium text-blue-500 flex rounded-md text-sm',
}
